(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zawq-product-detail"]) return;
  try {
    
document.addEventListener('change', function(event) {
  if (!event.target.matches('.zawq-pdp__sizes input[type="radio"]')) return;
  var section = event.target.closest('.zawq-pdp');
  var stock = section.querySelector('[data-zawq-stock]');
  var quantity = event.target.getAttribute('data-stock');
  if (stock && quantity !== null) stock.textContent = quantity + ' available in ' + event.target.nextElementSibling.textContent.trim();
});
document.addEventListener('click', function(event) {
  var button = event.target.closest('.zawq-pdp__thumbnail');
  if (!button) return;
  var section = button.closest('.zawq-pdp');
  var image = section.querySelector('.zawq-pdp__main-image .zawq-pdp__image');
  if (!image) return;
  image.removeAttribute('srcset');
  image.src = button.getAttribute('data-zawq-image');
  image.alt = button.getAttribute('data-zawq-image-alt') || '';
  section.querySelectorAll('.zawq-pdp__thumbnail').forEach(function(item) { item.classList.remove('is-active'); });
  button.classList.add('is-active');
});
document.addEventListener('change', function(event) {
  var form = event.target.closest('.zawq-pdp__form');
  if (!form) return;
  var quantityInput = form.querySelector('input[name="quantity"]');
  if (event.target.matches('.zawq-pdp__sizes input[type="radio"]')) {
    var available = parseInt(event.target.getAttribute('data-stock'), 10) || 0;
    form.querySelectorAll('.zawq-pdp__bundle-list input').forEach(function(bundle) {
      bundle.disabled = parseInt(bundle.getAttribute('data-zawq-qty'), 10) > available;
    });
    var checked = form.querySelector('.zawq-pdp__bundle-list input:checked');
    if (!checked || checked.disabled) {
      checked = form.querySelector('.zawq-pdp__bundle-list input[data-zawq-qty="1"]');
      checked.checked = true;
    }
    if (quantityInput) quantityInput.value = checked.getAttribute('data-zawq-qty');
  }
  if (event.target.matches('.zawq-pdp__bundle-list input') && quantityInput) {
    quantityInput.value = event.target.getAttribute('data-zawq-qty');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zawq-sales-funnel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.zawq-campaign__hero').forEach(function(hero) {
    var video = hero.querySelector('.zawq-campaign__hero-video');
    var chair = hero.querySelector('.zawq-campaign__hero-chair');
    if (!video || !chair) return;
    video.muted = true;
    video.play().catch(function() {});
    video.addEventListener('ended', function() {
      video.classList.remove('is-active');
      chair.classList.add('is-active');
      window.setTimeout(function() {
        chair.classList.remove('is-active');
        video.currentTime = 0;
        video.classList.add('is-active');
        video.play().catch(function() {});
      }, 5000);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
